import { agentRootApi } from '../api.ts';
import type { APIResponse } from '../types.ts';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({
  breaks: false,
});

const agentApi = agentRootApi.injectEndpoints({
  endpoints: build => ({
    askAgent: build.mutation<string, { input: string }>({
      query: ({ input }) => ({
        url: '/query',
        method: 'POST',
        body: { input },
      }),
      transformResponse: async (response: APIResponse<string>) => {
        const result = response?.data ?? '';
        const html = await marked.parse(result);
        return DOMPurify.sanitize(html);
      },
    }),
  }),
});

export const { useAskAgentMutation } = agentApi;
export default agentApi;
